<style>
.noClick {
  pointer-events: none;
}

.pointer {
  cursor: pointer;
}
</style>

<template>
  <div>

    <!-- Titulo -->
    <div class="no-background mt-96">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center text">
            <h1 class="custom-h1 primary-color"><b>Pesquisa de acordos</b></h1>
            <div class="mt-16">
              <h4 class="custom-h4 orange-color mt-16 text-center">
                {{ searchType === 'sams' ? 'SNQTB Saúde' : 'Plano Saúde SNQTB' }} </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-background mt-96">
      <div class="container">
        <div class="row">

          <!-- Filtros -->
          <!--<div id="myFilter" class="overlay">

              <div class="background primary-color">

                  <div class="col-12">

                      <div class="">
                          <h6 class="custom-h6 primary-color">região</h6>
                          <div class="mt-16 custom-input-dropdown dropdown w-100">
                              <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ distrito === null ? 'Todos as regiões' : distrito }}  <i class="fas fa-angle-down"></i>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                  <a class="custom-p block sm secondary-color mt-8" v-for="d in filterDistritos" v-on:click="distrito = d.distrito ">{{ d.distrito }}</a>
                              </div>
                          </div>
                      </div>

                      <div class="mt-32" :class="{'disable' : distrito === null, 'noClick' : distrito === null}">
                          <h6 class="custom-h6 primary-color">concelho</h6>
                          <div class="mt-16 custom-input-dropdown dropdown w-100">
                              <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                  {{ concelho === null ? 'Todos os concelhos' : concelho }} <i class="fas fa-angle-down"></i>
                              </a>
                              <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">

                                  <a class="custom-p block sm secondary-color mt-8" v-for="d in filterConcelhos" v-on:click="concelho = d.concelho ">{{ d.concelho }}</a>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>

              <br /><br /><br />

              <div class="mt-96"></div>

          </div>

          <div id="filter-btn" class="col-12 btn-hide-mobile" style="position:relative;">
              <a class="a-link sm lessWeight w-icon black-color mt-24" onclick="filter()">
                  <div class="custom-icon secondary-color">
                      <i id="icon" class="fas fa-filter"></i>
                  </div>

                  <span id="icon-text">Abrir Filtros</span>
              </a>

              <i id="filter-arrow" class="fas fa-chevron-right mb-5" style="position:absolute; top:8px; right:15px;"></i>

          </div>-->

          <!-- Left -->
          <div class="col-lg-8 ">
            <div class="input-search">
              <input type="text" v-model="searchTerm" placeholder="Pesquisar no SNQTB…" id="searchIn"
                     :class="{'border-danger' : termosValidation}" border="1"
                     name="search" v-on:keyup.enter="doSearch">
              <img class="pointer" v-on:click="doSearch" src="assets/images/search_icon.png">
            </div>
          </div>

          <div class="col-lg-3 offset-lg-1 ">

          </div>

          <div class="col-lg-8 ">
            <div v-if="termosValidation" class="text-danger small float-left">{{ termosValidation }}</div>

            <p v-if="searchedTerm && searchMade" class="custom-p gray-color mt-32">
              {{ totalResults }} resultados para ‘{{searchedTerm }}’
            </p>
            <p v-else-if="searchMade" class="custom-p gray-color mt-32">{{ totalResults }} resultados</p>


            <div class="mt-32">
              <GmapMap ref="mapRef" v-show="searchResults.length > 0"
                       :center="{lat:38.736946, lng:-9.142685}"
                       :zoom="7"
                       map-type-id="terrain"
                       style="width: 100%; height: 405px; margin-top:5px; margin-bottom:20px;">
                <GmapMarker
                    :key="index"
                    v-for="(m, index) in searchPins"
                    v-if="m.position !== null && m.position.lat !== null"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    @click="openInfoWindowTemplate(m)">
                </GmapMarker>

                <gmap-info-window
                    :options="{maxWidth: 350, pixelOffset: {width: 0, height: -35}}"
                    :position="infoWindow.position"
                    :opened="infoWindow.open"
                    @closeclick="infoWindow.open=false">
                  <div v-html="infoWindow.template"></div>
                </gmap-info-window>
              </GmapMap>
            </div>

            <div v-if="loadingData" class="d-flex justify-content-center">
              <div class="spinner-border" role="status">
                <span class="sr-only">A carregar...</span>
              </div>
            </div>


            <div v-if="searchMade">
              <app-search-saude-item v-for="(searchResult, index) in searchResults"
                                     :key="index" :filtro-especialidade="searchedEspecialidade" :origin="origin"
                                     :index="index" :searchResult="searchResult"></app-search-saude-item>

              <div v-if="totalResults > 0 && totalResults > currentPageView * 20">
                <a class="custom-btn-secondary inline mt-40"
                   v-on:click="currentPageView = currentPageView + 1">CARREGAR MAIS 20 RESULTADOS </a>
              </div>
              <div v-if="totalResults > 0 && totalResults <= currentPageView * 20">
                <hr class="special-line-no-margin mt-24 btn-hide-mobile"/>
                <span class="custom-p sm gray-color mt-40">Fim da lista de resultados.</span>
              </div>
            </div>
          </div>

          <!-- Rigth -->
          <div v-if="searchMedicoMade" class="col-lg-3 offset-lg-1 ">

            <div class="container">
              <div class="row text agenda">

                <!-- Filtrar resultados -->
                <div class="">
                  <h3 class="custom-h4">Filtrar Resultados</h3>

                  <div class="mt-32">
                    <a class="a-link sm lessWeight w-icon black-color"
                       v-on:click="searchType = 'sams'">
                      <div class="custom-icon"
                           :class="{'secondary-color': searchType === 'sams', 'gray-color': searchType !== 'sams'}">

                        <img src="assets/images/white_shield.svg"/>

                        <!--<i class="fas fa-infinity"></i>-->

                      </div>
                        SNQTB Saúde
                    </a>
                  </div>

                  <div class="mt-32">
                    <a class="a-link sm lessWeight w-icon black-color"
                       v-on:click="searchType = 'familia'">
                      <div class="custom-icon"
                           :class="{'secondary-color': searchType === 'familia', 'gray-color': searchType !== 'familia'}">

                        <img src="assets/images/white_heart.svg"/>

                        <!--<i class="fas fa-infinity"></i>-->

                      </div>
                        Plano Saúde SNQTB
                    </a>
                  </div>

                </div>

              </div>

            </div>

            <div class="mt-32">
              <h6 class="custom-h6 primary-color">especialidades</h6>
              <div class="mt-16 custom-input-dropdown dropdown w-100">
                <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false">
                  {{ especialidade === null ? 'Todas as especialidades' : especialidade }} <i
                    class="fas fa-angle-down"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                  <a class="custom-p block sm secondary-color mt-8" v-for="esp in especialidades"
                     v-on:click="especialidade = esp.especialidade">{{ esp.especialidade }}
                  </a>
                </div>
              </div>
            </div>

            <div class="mt-32">
              <h6 class="custom-h6 primary-color">região</h6>
              <div class="mt-16 custom-input-dropdown dropdown w-100">
                <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false">
                  {{ distrito === null ? 'Todos as regiões' : distrito }} <i
                    class="fas fa-angle-down"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">

                  <a class="custom-p block sm secondary-color mt-8" v-for="d in filterDistritos"
                     v-on:click="distrito = d.distrito ">{{ d.distrito }}</a>

                </div>
              </div>
            </div>

            <div class="mt-32" :class="{'disable' : distrito === null, 'noClick' : distrito === null}">
              <h6 class="custom-h6 primary-color">concelho</h6>
              <div class="mt-16 custom-input-dropdown dropdown w-100">
                <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false">
                  {{ concelho === null ? 'Todos os concelhos' : concelho }} <i
                    class="fas fa-angle-down"></i>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">

                  <a class="custom-p block sm secondary-color mt-8" v-for="d in filterConcelhos"
                     v-on:click="concelho = d.concelho ">{{ d.concelho }}</a>

                </div>
              </div>
            </div>

            <div class="mt-32">
              <button class="custom-btn-primary"
                      @click="doSearch">Pesquisar
              </button>
            </div>
            <div class="mt-32">
              <a class="text-decoration-none" v-on:click="clearSearch">
                <span class="custom-h6 orange-direct">Limpar Pesquisa </span>
              </a>
            </div>

          </div>


        </div>
      </div>
    </div>

    <div class="mt-96"></div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import SearchSaudeItem from './SearchSaudeItem.vue';
import {iframeResizerContentWindow} from 'iframe-resizer';
// This needs to be referenced so it isn't tree-shaken.
iframeResizerContentWindow; // tslint:disable-line no-unused-expression

export default {
  // components: {},
  props: ['medico', 'user', 'token'],
  data() {
    return {
      currentPageView: 1,
      origin: 'search',
      searchType: 'sams',
      searchTerm: '',
      searchedTerm: null,
      concelho: null,
      distrito: null,
      areaData: [],
      searchResults: [],
      searchDistritos: [],
      searchConcelhos: [],
      searchPinsWithoutPosition: [],
      searchPins: [],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: '',
      },
      loadingData: false,
      searchMade: false,
      searchMedicoMade: true,
      termosValidation: null,
      totalResults: 0,
      hasFavorites: false,

      especialidades: [],
      especialidade: null,
      searchedEspecialidade: null,
    };
  },
  created() {
    console.log("Search saude...");
      const self = this;
      if (self.$route.params.user) {
        this.checkDirPesToken({
              user: self.$route.params.user,
              token: self.$route.params.token
            })
            .then(() => {
              this.fetchData()
            })
            .catch(() => {
              this.fetchData()
            })
      } else {
        this.fetchData();
      }
  },
  activated() {
    this.doSearch(false);
  },
  watch: {
    medico: function() {
      this.checkLoadDataForMedico(this.medico);
    },
    currentPageView(val) {
      if (val > 1) {
        this.loadSearchForNewPage();
      }
    },
    concelho(val) {
      if (!val) {
        this.concelho = null;
      }
      this.currentPageView = 1;
    },
    distrito() {
      this.currentPageView = 1;
      this.concelho = null;
    },
    especialidade() {
      this.currentPageView = 1;
      if (this.especialidade !== null) {
        this.loadFilteredAreas();
      } else {
        this.loadAllDistritosConcelhos();
      }
    },
    searchType() {
      this.currentPageView = 1;
      this.doSearch(true);
    },
    searchPins() {
      //console.log("searchPins " + this.searchPins.length);
      this.$refs.mapRef.$mapPromise.then(() => {
        const bounds = new google.maps.LatLngBounds();
        const vm = this;
        for (const m of this.searchPins) {
          bounds.extend(m.position);
          if (vm.$refs.mapRef.$mapObject !== undefined && this.searchPins.length > 1)
            vm.$refs.mapRef.$mapObject.fitBounds(bounds);
        }
      });
    },
    searchPinsWithoutPosition() {
      if (this.searchPinsWithoutPosition.length > 0) {
        const geocoder = new google.maps.Geocoder();
        const vm = this;
        const ids = [];
        let pos = 0;
        for (const m of this.searchPinsWithoutPosition) {
          //console.log("without " + this.searchPinsWithoutPosition.length + " latitude: " + m.position.lat);
          if (m.position.lat !== null) {
            vm.searchPins = vm.searchPins.concat(m);
            //console.log("---- From cache " + m.localidade + " " + m.position.lat);
          } else {
            //console.log("2");
            vm.sleep(200 * pos).then(() => {
              vm.doSearchAddress(geocoder, vm, m, ids, 1);
              // Do something after the sleep!
            });
            pos = pos + 1;
          }
        }
        this.searchPinsWithoutPosition = [];
      }
    },
  },
  computed: {
    ...mapGetters('dirpesquisador',
        {
          userCurrentLocation: 'getUserCurrentLocation',
          loggedUser: 'getLoggedUser',
          loggedToken: 'getLoggedToken'
        },
    ),
    filterDistritos() {
      let self = this
      return this.areaData.filter((item) => {
        if (self.searchedTerm && self.searchResults.length > 0) {
          return item.concelho === null && item.distrito !== null && self.searchDistritos.includes(item.distrito)
        }
        return item.concelho === null && item.distrito !== null
      })
          .sort(function (a, b) {
            return a.distrito.localeCompare(b.distrito);
          });
    },
    filterConcelhos() {
      if (!this.distrito) {
        this.distrito = null;
        return [];
      }
      const self = this;
      return this.areaData.filter((item) => {
        if (self.searchedTerm && self.searchResults.length > 0) {
          return self.distrito === item.distrito && item.concelho !== null && self.searchConcelhos.includes(item.concelho)
        }
        return self.distrito === item.distrito && item.concelho !== null
      })
          .sort(function (a, b) {
            return a.concelho.localeCompare(b.concelho);
          });
    },
  },
  components: {
    appSearchSaudeItem: SearchSaudeItem,
  },
  methods: {
    ...mapActions('dirpesquisador',
        {
          performSearch: 'performSearch',
          addAddressToCache: 'addAddressToCache',
          loadDistritosConcelhosItem: 'loadDistritosConcelhosItem',
          loadEspecialidades: 'loadEspecialidades',
          loadAreasByEspecialidades: 'loadAreasByEspecialidades',
          checkDirPesToken: 'checkDirPesToken',
          scrollFrameTop: 'scrollFrameTop',
        },
    ),
    doSearchAddress(geocoder, vm, m, ids, attempt) {
      if (attempt > 1 || (m.morada !== null && !ids.includes(m.idAcordoMorada))) {
        if (attempt === 1)
          ids.push(m.idAcordoMorada);

        let address = m.morada + ' ' + m.cp4 + '-' + m.cp3 + ' ' + m.localidade + ' ' + m.concelho + ' ' + m.distrito;
        // console.log(new Date() + "checking " +  address + " attempt: " + attempt);
        geocoder.geocode({address: address}, function (results, status) {
              if (status === google.maps.GeocoderStatus.OK) {
                // Adicionada logica por causa de posições devolvidas que nao faziam sentido.
                // Ex: Hospital Misericordia de Evora devolvia uma morada no Brasil.
                let found = false;
                for (const resultsPos of results) {
                  for (const resultAddress of resultsPos.address_components) {
                    if (resultAddress.types.length > 0 &&
                        resultAddress.types[0].startsWith('administrative_area_level')) {
                      const admin = resultAddress.long_name;
                      if (admin === m.concelho || admin === m.distrito || admin === m.localidade) {
                        m.position.lat = resultsPos.geometry.location.lat();
                        m.position.lng = resultsPos.geometry.location.lng();

                        vm.searchPins = vm.searchPins.concat(m);
                        found = true;

                        //console.log("add to cache " + address);
                        vm.addAddressToCache(
                            {
                              morada: m.morada,
                              cp: m.cp4 + '-' + m.cp3,
                              localidade: m.localidade,
                              concelho: m.concelho,
                              distrito: m.distrito,
                              latitude: m.position.lat,
                              longitude: m.position.lng,
                              protocol: false
                            },
                        ).then(() => {
                          // console.log(response);
                        }).catch(() => {
                        });
                        break;
                      }
                    }
                  }
                  if (found) {
                    break;
                  }
                }
                if (!found) {
                  m.position.lat = results[0].geometry.location.lat();
                  m.position.lng = results[0].geometry.location.lng();

                  vm.searchPins = vm.searchPins.concat(m);
                  //console.log("add to cache " + address);
                  vm.addAddressToCache(
                      {
                        morada: m.morada,
                        cp: m.cp4 + '-' + m.cp3,
                        localidade: m.localidade,
                        concelho: m.concelho,
                        distrito: m.distrito,
                        latitude: m.position.lat,
                        longitude: m.position.lng,
                        protocol: false
                      },
                  ).then(() => {
                    // console.log(response);
                  }).catch(() => {
                  });
                }
              } else {
                if (status !== google.maps.GeocoderStatus.OVER_QUERY_LIMIT || attempt > 10) {
                  console.error('GEOCODE FAILED PARA MORADA => \'' + address + '\' STATUS=' + status);
                } else {
                  let next = attempt + 1;
                  vm.sleep(1600).then(() => {
                    vm.doSearchAddress(geocoder, vm, m, ids, next);
                  });
                }
              }
            },
        );
      }
    },

    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    doSearch(showError) {
      const self = this;
      this.searchMade = false;
      let goForSearch = false;

      if (this.searchTerm !== '' && this.searchTerm.length > 2) {
        goForSearch = true;
      } else {
        if (this.searchTerm !== '') {
          if (showError)
            this.termosValidation = 'O termo de pesquisa necessita ter no mínimo 3 caracteres';
          return;
        }
      }

      if (!goForSearch) {
        if (
            (this.especialidade !== '' && this.especialidade !== null &&
            this.distrito !== '' && this.distrito !== null) //|| this.searchType === 'favoritos'
        ) {
          goForSearch = true;
        } else {
          if (showError)
            this.termosValidation = 'Deverá definir um termo de pesquisa ou, pelo menos, a especialidade e região';
        }
      }

      if (goForSearch) {
        this.termosValidation = null;
        this.loadingData = true;
        this.searchedTerm = this.searchTerm;

        let searchInput =  this.searchedTerm ;
        if (this.especialidade !== null) {
          searchInput = this.searchedTerm + ' ' + this.especialidade;
        }
        this.currentPageView = 1;
        this.searchResults = [];
        this.searchDistritos = [];
        this.searchConcelhos = [];
        this.searchPins = [];
        this.searchPinsWithoutPosition = [];
        this.searchedEspecialidade = this.especialidade;

        this.scrollFrameTop();
        this.performSearch(
            {
              type: this.searchType,
              search: searchInput,
              distrito: this.distrito,
              concelho: this.concelho,
              currentPageView: this.currentPageView,
              especialidade: this.especialidade,
              user: this.loggedUser,
              token: this.loggedToken,
            },
        ).then((response) => {
          console.log('Elapse time: -> '  + response.loggingTime);
          self.searchResults = response.list;
          self.searchDistritos = response.listDistritos;
          self.searchConcelhos = response.listConcelhos;
          self.searchPinsWithoutPosition = response.pins;
          self.totalResults = response.total;
          self.hasFavorites = response.hasFavorites;
          this.loadingData = false;
          this.searchMade = true;
          this.searchMedicoMade = true;
          if (this.medico !== null && this.medico !== undefined) {
            this.medico = null;
          }
          this.scrollFrameTop();
        }).catch(() => {
          this.searchMedicoMade = true;
        });
      }
    },
    loadSearchForNewPage() {
      const self = this;
      let searchInput =  this.searchedTerm ;
      if (this.especialidade !== null) {
        searchInput = this.searchedTerm + ' ' + this.especialidade;
      }

      this.termosValidation = null;
      this.loadingData = true;
      this.searchedEspecialidade = this.especialidade;
      this.performSearch(
          {
            type: this.searchType,
            search: searchInput,
            distrito: this.distrito,
            concelho: this.concelho,
            currentPageView: this.currentPageView,
            especialidade: this.especialidade,
            user: this.loggedUser,
            token: this.loggedToken,
          },
      ).then((response) => {
        console.log('Elapse time: -> '  + response.loggingTime);
        this.loadingData = false;
        this.searchMade = true;
        self.totalResults = response.total;
        self.hasFavorites = response.hasFavorites;
        self.searchResults = self.searchResults.concat(response.list);
        self.searchPinsWithoutPosition = self.searchPinsWithoutPosition.concat(response.pins);
      }).catch((error) => {
      });
    },
    clearSearch() {
      this.searchMade = false;
      this.concelho = null;
      this.distrito = null;
      this.searchTerm = '';
      this.termosValidation = null;
      this.searchResults = [];
      this.searchConcelhos = [];
      this.searchDistritos = [];
      this.searchPins = [];
      this.searchPinsWithoutPosition = [];
      this.currentPageView = 1;
      this.searchedTerm = null;
      this.totalResults = 0;
      this.especialidade = null;
      this.searchedEspecialidade = null;
      this.scrollFrameTop();
    },
    fetchData() {
//      this.checkLoadDataForMedico(this.$route.params.medico);
      this.loadAllDistritosConcelhos();
      this.loadAllEspecialidades();
    },

    checkLoadDataForMedico(medico) {
      if (medico !== null && (typeof medico !== 'undefined')) {
        //console.log('Checking for medico ' + medico);
        this.clearSearch();
        this.searchTerm = medico;
        this.searchMade = false;

        this.searchMedicoMade = false;
        this.searchType = 'sams';

        this.doSearch();
      }
    },
    openInfoWindowTemplate(item) {
      this.infoWindow.template = item.infoText + (item.medico !== null ?
          ('<br/><br/>Medico(s):</br>' + item.medico) : '');
      this.infoWindow.position = item.position;
      this.infoWindow.open = true;
    },

    loadAllEspecialidades() {
      let self = this
      this.loadEspecialidades()
          .then((response) => {
            // console.log(response)
            self.especialidades = response.especialidades
          })
          .catch((error) => {
            console.error('Error loading especialidades!', error);
          })
    },
    loadAllDistritosConcelhos() {
      let self = this
      this.loadDistritosConcelhosItem()
          .then((response) => {
            self.areaData = response.list;
          })
          .catch(() => {
            console.log('Error loading distritos and concelhos!');
          });
    },

    loadFilteredAreas() {
      let self = this
      this.loadAreasByEspecialidades(
          {
            especialidade: this.especialidade,
          })
          .then((response) => {
            // console.log(response)
            self.areaData = response.list;
          })
          .catch((error) => {
            console.error('Error loading especialidades!', error);
          })
    },
  },
};
</script>
